import { render, staticRenderFns } from "./ProductCategoryForm.vue?vue&type=template&id=83843c60&"
import script from "./ProductCategoryForm.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports